import { Button, Drawer, Spin, Typography } from "@arco-design/web-react";

import type { OpportunityQuickCreateCheck } from "../types";
import "./QuickOpportunityDrawer.css";

/** 快捷新建商机抽屉，仅展示归属和严格去重结果，不编辑联系人资料。 */
export function QuickOpportunityDrawer({
  visible,
  check,
  loading,
  creatingMonth,
  onCancel,
  onCreate,
}: {
  visible: boolean;
  check?: OpportunityQuickCreateCheck;
  loading: boolean;
  creatingMonth?: string;
  onCancel: () => void;
  onCreate: (travelMonth: string) => void;
}) {
  const context = check?.context;
  return (
    <Drawer
      className="crm-opportunity-workbench-drawer"
      title="快捷新建商机"
      width={620}
      visible={visible}
      footer={null}
      onCancel={onCancel}
    >
      {loading && !check ? (
        <div className="crm-contact-workbench-detail-loading">
          <Spin />
        </div>
      ) : check ? (
        <div className="crm-quick-opportunity">
          <section className="crm-quick-opportunity-summary">
            <Typography.Title heading={6}>商机归属</Typography.Title>
            <div><span>学校</span><strong>{context?.orgName || "-"}</strong></div>
            <div><span>二级学院</span><strong>{context?.collegeUnitName || "学院待补"}</strong></div>
            <div><span>客户</span><strong>{context?.customerName || "客户为空（保留联系人）"}</strong></div>
            <div><span>联系人</span><strong>{context?.contactName || "-"}</strong></div>
            <div><span>动态标签</span><strong>{context?.labelsSnapshot || "-"}</strong></div>
          </section>
          {check.blocked ? (
            <section className="crm-quick-opportunity-blocked" role="alert">
              <Typography.Text type="warning">暂不能从快捷入口创建</Typography.Text>
              <p>{check.blockedReason}</p>
              <p>请先完善联系人/历史商机信息，或前往商机工作台人工新增。</p>
            </section>
          ) : (
            <section className="crm-quick-opportunity-candidates">
              <Typography.Title heading={6}>出行月份与去重结果</Typography.Title>
              {check.candidates.length === 0 ? (
                <Typography.Text type="secondary">
                  没有可创建的标准出行月份，请前往商机工作台人工新增。
                </Typography.Text>
              ) : check.candidates.map((candidate) => (
                <div className="crm-quick-opportunity-candidate" key={candidate.travelMonth}>
                  <div>
                    <strong>{formatQuickTravelMonth(candidate.travelMonth)}</strong>
                    {candidate.canCreate ? (
                      <Typography.Text type="success">可创建</Typography.Text>
                    ) : (
                      <Typography.Text type="warning">已有商机</Typography.Text>
                    )}
                  </div>
                  {candidate.existingOpportunities.length ? (
                    <div className="crm-quick-opportunity-existing">
                      {candidate.existingOpportunities.map((item) => (
                        <span key={item.id}>{item.opportunityCode} {item.opportunityName}</span>
                      ))}
                    </div>
                  ) : null}
                  {candidate.canCreate ? (
                    <Button
                      type="primary"
                      size="small"
                      loading={creatingMonth === candidate.travelMonth}
                      disabled={loading}
                      onClick={() => onCreate(candidate.travelMonth)}
                    >
                      创建此月份商机
                    </Button>
                  ) : (
                    <Typography.Text type="secondary">
                      同学校、同二级学院、同出行阶段不可重复创建
                    </Typography.Text>
                  )}
                </div>
              ))}
            </section>
          )}
        </div>
      ) : null}
    </Drawer>
  );
}

/** 格式化快捷商机月份展示文本。 */
function formatQuickTravelMonth(value: string) {
  const match = value.match(/^\d{4}-(\d{2})$/);
  return match ? `${Number(match[1])}月出行（${value.slice(0, 4)}）` : value;
}
